import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ClaveUnicaService } from '../../services/claveunica.service';

@Component({
  selector: 'app-claveunica-button',
  standalone: true,
  imports: [],
  templateUrl: './claveunica-button.component.html',
  styleUrl: './claveunica-button.component.css',
})
export class ClaveUnicaButtonComponent {
  private readonly claveUnicaService = inject(ClaveUnicaService);
  private readonly router = inject(Router);

  @Input() tokenCU?: string;

  get isConfigured(): boolean {
    return this.claveUnicaService.isConfigured();
  }

  async onLogin(): Promise<void> {
    try {
      if (!this.tokenCU || this.tokenCU.trim() === '') {
        // Lanzar error con status 401 si el token es vacío o no existe
        throw { status: 401, message: 'Token de ClaveÚnica no proporcionado' };
      }
      await this.claveUnicaService.iniciarAutenticacion(this.tokenCU);
    } catch (error: unknown) {
      // Ignorar el error "Navigation in progress" que se lanza intencionalmente
      // durante la redirección exitosa a ClaveÚnica
      if (
        error instanceof Error &&
        error.message === 'Navigation in progress'
      ) {
        return;
      }

      console.error('Error al iniciar autenticación:', error);

      // Determinar el tipo de error
      let tipoError = 'general';

      if (
        typeof error === 'object' &&
        error !== null &&
        'status' in error
      ) {
        const status = (error as { status: number }).status;
        if (status === 401) {
          tipoError = 'auth'; // Sesión expirada
        } else if (status === 403) {
          tipoError = 'forbidden'; // Acceso denegado
        } else if (status === 408) {
          tipoError = 'timeout';
        } else if (status >= 500) {
          tipoError = 'server';
        }
      } else if (
        error instanceof Error &&
        error.message.includes('timeout')
      ) {
        tipoError = 'timeout';
      }

      // Redirigir a la página de error específica de ClaveÚnica
      // Construir la ruta anterior incluyendo el token si existe
      const rutaAnterior = this.tokenCU
        ? `/claveunica?token=${this.tokenCU}`
        : this.router.url || '/claveunica';

      this.router.navigate(['/claveunica/error'], {
        state: {
          tipoError,
          rutaAnterior,
        },
      });
    }
  }
}
